module.exports = __webpack_public_path__ + "static/media/IMG-8.635714c2.jpg";